import { useEffect, useState } from 'react';

export default function useBrowserNavigationDetection() {
  const [isBottomNavVisible, setIsBottomNavVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Detect if scrolling up (likely to reveal the bar) or near the top
      if (currentScrollY < lastScrollY || currentScrollY === 0) {
        setIsBottomNavVisible(true);
      } else {
        setIsBottomNavVisible(false);
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  return { isBottomNavVisible };
}
